export default __webpack_public_path__ + "static/media/microsoft.45474abe.png";